import { Box, Flex } from '@everlywell/ui-kit';
import { usePrePurchaseQuizContext } from 'contexts/PrePurchaseQuiz/PrePurchaseQuizContext';
import React from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import useMdpModals from 'utils/hooks/useMdpModals';
import { ContentfulFlag } from 'utils/types/contentfulTypes';

import SectionContainer from '../components/SectionContainer';
import SectionHeader from '../components/SectionHeader';
import Card, { CardProps, SecondaryCardProps } from './components/Card';

export interface PriceSectionCard extends CardProps {
  isVisible: ContentfulFlag;
  secondaryCard?: SecondaryCardProps;
}

export type PricingSelectorV2Props = {
  eyebrow?: string | null;
  title?: string | null;
  priceSections?: PriceSectionCard[] | null;
};

export default function PricingSelectorV2({
  eyebrow,
  title,
  priceSections,
}: PricingSelectorV2Props) {
  const { handleMdpCtaClick } = useMdpModals();
  const { setShowPricingInPPQ } = usePrePurchaseQuizContext();

  const [expandedCardIndex, setExpandedCardIndex] = React.useState<number>(0);

  const handleMainCardClick = (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    ctaUrl: string,
    ctaLabel: string,
  ) => {
    handleMdpCtaClick({ event, ctaUrl });
    setShowPricingInPPQ(false);
    trackMainCtaClick(ctaLabel);
  };

  const trackMainCtaClick = (ctaLabel: string) => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        sectionHeader: title || 'No title provided',
        contentfulSection: 'PricingSelectorV2',
        ctaText: ctaLabel || 'No CTA label',
      },
    });
  };

  return (
    // TODO: Set section background color in Contentful
    <Box
      backgroundColor="#FBF4FB"
      data-testid="pricing-selector"
      paddingY={[10, null, 20]}
    >
      <SectionContainer>
        <SectionHeader eyebrow={eyebrow} title={title} />

        <Flex
          gap="4"
          flexDirection={['column', null, 'row']}
          flexWrap="nowrap"
          justifyContent="space-between"
        >
          {priceSections?.map((priceSection, index) => {
            let isExpanded = index === expandedCardIndex;

            return (
              <Box
                key={index}
                width={['100%', null, isExpanded ? '60%' : '40%']}
              >
                <Card
                  {...priceSection}
                  onCtaClick={(event, ctaUrl, ctaLabel) =>
                    handleMainCardClick(event, ctaUrl, ctaLabel)
                  }
                  isExpanded={isExpanded}
                  handleCollapsedCTAClick={() => setExpandedCardIndex(index)}
                  secondaryCard={priceSection.secondaryCard}
                />
              </Box>
            );
          })}
        </Flex>
      </SectionContainer>
    </Box>
  );
}
